import { Component, Input, OnInit } from "@angular/core";
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from "@ptl/account-management";
import { RedirectService } from "src/app/angular-elements/shared/services/redirect.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";

@Component({
    selector: 'app-curtis-direct-sso',
    templateUrl: './curtis-direct-sso.component.html',
    styleUrls: ['./curtis-direct-sso.component.scss'],
    standalone: false
})
export class CurtisDirectSSOComponent implements OnInit {

    @Input() label: string;

    constructor(
        private reducerUtilityService: ReducerUtilityService,
        private redirectService: RedirectService
    ) { }

    ngOnInit() { }

    submitSSOForm() {

        const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

        if (!loginInfo.userId) {
            console.error('No userId in loginInfo state, stopping SSO');
            return;
        }
        
        let destinationURL = "";
        if (window.location.hostname.includes('env')) {
            destinationURL = 'train.curtisdirect.com/sso/gensso.cfm';
        } else {
            destinationURL = 'curtisdirect.com/sso/gensso.cfm';
        }

        let target = "https://" + destinationURL;

        let postParams = { 'iv-user': loginInfo.userId, target }
        this.redirectService.post(postParams);
    }

}